export default "__VITE_ASSET__437c76ab__"